import { prop, path } from 'core/utils';

export const mediateTokenInfoDependent = path(['login', 'accessToken']);
export const mediateLoginInfoDependent = prop('login');
